import create from "zustand";

export interface InteracPurchaseDetails {
    purchaseId: ID;
    itemId?: ID;
}

export interface InteracPurchaseRefundStore {
    isOpen: boolean;
    interacPurchaseDetails: InteracPurchaseDetails[] | null;
    setOpen: () => void;
    setClose: () => void;
    setInteracPurchaseDetails: (interacPurchaseDetails: InteracPurchaseDetails[] | null) => void;
}

export const useInteracPurchaseRefundStore = create<InteracPurchaseRefundStore>((set) => ({
    isOpen: false,
    interacPurchaseDetails: null,
    setOpen: () => set(() => ({ isOpen: true })),
    setClose: () => set(() => ({ isOpen: false, interacPurchaseDetails: null })),
    setInteracPurchaseDetails: (interacPurchaseDetails: InteracPurchaseDetails[] | null) =>
        set(() => ({ interacPurchaseDetails })),
}));
